import React , { useState , useEffect } from 'react'
import DoCaseCard01 from './DoCaseCard01'
import DoCasePlus from './DoCasePlus'

import axios from 'axios'


import { ApiCallGet } from '../ApiCall/ApiCall'


var arr = [

]


function DoCase01( {cardsPlus ,  theCards , theProduct , code = "" , theCode  , clean }) {

    const [cards,setCards] = useState( [])
    const [lastCode,setLastCode] = useState( "" ) ;


    useEffect(() => {

        if ( clean === true )
        {
            setCards( [] ) 
        }

    }, [clean])


    useEffect(() => {


        console.log( "LoadThird???????????????????? code = " + code ) ;
    
        loadThird() ;
    
    },[code])
    

    function loadThird() // Hacemos la carga del tercer nivel
    {

        code = code.replace("-" , "")

        if ( code === "err")
        {
    
            setCards( [])
            return ;
        }
    
        console.log( "DoCase01 code = " + code ) ;

        if ( code === "" )
        {
            console.log( "saliendo")
            return ;
        }
    
        ApiCallGet( "getSecondLength/?code=" + code + "&len=3"  )
        .then((response) => {
    
                console.log( "DoCase01 response = " + JSON.stringify( response )) ;
    
                arr = []
        
                for( var i = 0 ; i < response.length ; i++ )
                {
                    var obj = {} ;
                    obj.id = response[i].idsecond  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response[i].parent ;
                    obj.field3 = response[i].second ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = response[i].name ;
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 = response[i].comment ;   
                    obj.naturaleza =  response[i].naturaleza ;
                    obj.tipo = response[i].tipo ;
        
                    arr.push( obj ) ;
            
                }
        
                console.log( "arr.length = " + arr.length )
                setCards( arr ) ;
       
            } ) 
            .catch( ( err ) => {
        
                console.log( "Tenemos un error")
                console.log( err ) ;
            })
    
    
      //}
    

    } 


    function theProducto( index )
    {
        console.log( "Se selecciono el index(3) = " + JSON.stringify( cards[index] ) ) ;

        //setSelected( arr[index] )

        // console.log( "field3 = " +  cards[index].field3 )

        // http://localhost:3004/livefactura/getSecondLength/?code=
        // http://localhost:3004/livefactura/getproductos/?grupo=

        axios.get(  "http://localhost:3004/livefactura/getSecondLength/?code="  + cards[index].field3 + "&len=4" )
        .then((response) => {
            console.log( "respuesta de  getProductos = " + JSON.stringify( response.data ) ) ;


            if ( response.data.length > 0 )
            {
                //setShowDrop( true ) ;
    
                var arr = [] ;
    
                for( var i = 0 ; i < response.data.length ; i++)
                {
                    console.log( "Codigo = " + response.data[i].name ) ;

                    var obj = {} ;
                    obj.id = response.data[i].idsecond  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response.data[i].parent ;
                    obj.field3 = response.data[i].second ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = response.data[i].name ;
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 = response.data[i].comment ;   
                    obj.idcatcasegroup = response.data[i].comment ;
                    obj.naturaleza =  response.data[i].naturaleza ;
                    obj.tipo =  response.data[i].tipo ;
    

                    // var obj = {} ;
                    // obj.id = response.data[i].idcatcasegroup  ; // idcasesatcodigo // idcasesatcodigo
                    // obj.field1 = response.data[i].value ;
                    // obj.field3 = response.data[i].tagName;  
                    // obj.field2 = "Marketing Director" ;
                    // obj.field4 = response.data[i].description ;
                    // obj.field5 = "Creado por Charly" ;
                    // obj.field6 =  ( response.data[i].ifthen === 1 ? "Tiene ifs" : "No tiene ifs" );     
                    
                    
                    arr.push( obj ) ;
    
                }
    
                console.log( "Llamando a theCards  " + JSON.stringify( arr ))

                theCards( arr ) ;

                theProduct( arr ) ;
    
            }
            else{
                //setShowDrop ( false ) ;
            }
    


        })
        .catch( (err) => {
            console.log( err) ;
        })

    }

    useEffect(() => {

        console.log( "lastCode(3) = " + lastCode )

    } , [lastCode])

    function theSelected( index )
    {
        console.log( "Se selecciono el index(2**) = " + index + "  length = " + cards.length ) ;

        console.log( JSON.stringify( cards[index] ))

        //http://localhost:3004/livefactura/getSecondLength/?code=

        //http://localhost:3004/livefactura/getCuentasAfectadas/?grupo=

        axios.get(  "http://localhost:3004/livefactura/getSecondLength/?code="  + cards[index].field3 + "&len=4" )
        .then((response) => {
            console.log( "response = " + JSON.stringify( response.data ) ) ;


            if ( response.data.length > 0 )
            {
                //setShowDrop( true ) ;
    
                var arr = [] ;
    
                for( var i = 0 ; i < response.data.length ; i++)
                {

                    console.log( "Codigo = " + response.data[i].second ) ;

                    var obj = {} ;
                    obj.id = response.data[i].second  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response.data[i].parent ;
                    obj.field3 = response.data[i].second ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = "Hola" ; // response.data[i].comentario ;
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 = "2024-02-11 17:01:02" ;   
                    obj.naturaleza =  response.data[i].naturaleza ;


                    
                    arr.push( obj ) ;
    
                }
    
                console.log( "Llamando a  a theCards *** " + JSON.stringify( arr ))

                theCards( arr ) ;

                theProducto( index )


                console.log( "Llamando a theCode + " +  cards[index].field3 )



                var myCode = cards[index].field3 ;
    

                console.log( "code = " + cards[index].field3 )
                console.log( "lastCode = " + lastCode )
        
                if ( cards[index].field3 === ( lastCode.replace( "-" , " ") ) )
                {
                    if ( lastCode.indexOf('-') >=0 )
                    {
                        myCode = cards[index].field3 ;
        
                    }
                    else{
        
                        myCode = '-' + myCode ;
        
                    }
                }
        
        
                console.log( "Cambiando codigo(3) " + myCode )
                setLastCode( myCode ) ;

                theCode( myCode ) ; //cards[index].field3


                //theCode( cards[index].field3 )
    
            }
            else{
                //setShowDrop ( false ) ;
            }
    


        })
        .catch( (err) => {
            console.log( err) ;
        })
    }


    useEffect( () => {

        console.log( "useEffect = " + JSON.stringify( cardsPlus ) ) ;

    } , [cardsPlus] )


  return (
    
        <>
            <div style={{overflowY:'auto' , overflowX :'hidden', height : '90%'}}>
                {/* <DoCaseCard01 data={arr[0]}></DoCaseCard01> */}

                {
                    cards.length > 0 && (

                        cards.map( ( elem , i ) =>
                            <DoCaseCard01 data={elem} naturaleza={elem.naturaleza} 
                             selected={theSelected} index={i}></DoCaseCard01>
                        )

                    )


                }
                {/* <DoCasePlus type={'group'}></DoCasePlus> */}

            </div>

            

        </>

  )
}

export default DoCase01